import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import InnerAttributeGroupsForm from '../../components/AttributeGroups/Form';

const AttributeGroupForm = ({classes, attributeGroups, attributeGroup}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('attribute.group.title')}
        />

        <div className={classes.layout}>
            <Paper className={classes.paper}>
                {attributeGroup ? (
                    /* Edit a already existing attribute group */
                    <InnerAttributeGroupsForm
                        method="PUT"
                        url={`/attribute-groups/${attributeGroup.id}`}
                        attributeGroups={attributeGroups}
                        values={attributeGroup}
                    />
                ) : (
                    /* Create a new attribute group */
                    <InnerAttributeGroupsForm
                        method="POST"
                        url="/attribute-groups"
                        attributeGroups={attributeGroups}
                    />
                )}
            </Paper>
        </div>
    </Layout>
);

const styles = theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(AttributeGroupForm);
